import React from "react";
import ToggleButton from "../../../../components/ToggleButton/index";
import { updatetDeliveryState } from "../../../../helper";

export default function Delivery(props) {
  const { deliveryState, setDeliveryState } = props;
  return (
    <div>
      <ToggleButton
        secondLabel="Enabled"
        firstLabel="Disabled"
        checkedValue={deliveryState}
        handleOnChange={async () =>
          updatetDeliveryState(!deliveryState).then(
            (result) => result && setDeliveryState(!deliveryState)
          )
        }
      />
    </div>
  );
}
